export default "__VITE_ASSET__c21d8dbd__"